import React, { Component } from 'react' // eslint-disable-line no-unused-vars

class ListPagination extends Component {
  getPaginationInfo (pageNumber, pageSize, totalPages) {
    let pageNumberList = []
    if (totalPages > 1) {
      if (totalPages === 2) {
        pageNumberList = [1, 2]
      } else {
        if (totalPages <= 4) {
          if (pageNumber === 1 || pageNumber === 2) {
            pageNumberList = [1, 2, 3]
          } else {
            if (pageNumber === totalPages) {
              pageNumberList = [pageNumber - 2, pageNumber - 1, pageNumber]
            } else {
              pageNumberList = [pageNumber - 1, pageNumber, pageNumber + 1]
            }
          }
        } else {
          if (pageNumber <= 3) {
            pageNumberList = [1, 2, 3, 4, 5]
          } else if (pageNumber === totalPages) {
            pageNumberList = [pageNumber - 4, pageNumber - 3, pageNumber - 2, pageNumber - 1, pageNumber]
          } else if (pageNumber === totalPages - 1) {
            pageNumberList = [pageNumber - 3, pageNumber - 2, pageNumber - 1, pageNumber, pageNumber + 1]
          } else {
            pageNumberList = [pageNumber - 2, pageNumber - 1, pageNumber, pageNumber + 1, pageNumber + 2]
          }
        }
      }
    }

    return {
      pageNumber,
      pageSize,
      totalPages,
      pageNumberList,
      isNext: pageNumber < totalPages,
      isPrev: pageNumber > 1
    }
  }

  render () {
    const {
      pageNumber,
      totalPages,
      isPrev,
      pageNumberList,
      isNext
    } = this.getPaginationInfo(
      this.props.pageNumber,
      this.props.pageSize,
      this.props.totalPages
    )

    const color = this.props.backgroundColor || 'white'

    return totalPages <= 1 ? null : (
      <div
        style={{ marginTop: '1px', width: '100%', paddingTop: '14px' }}
      >
        <table
          style={{
            border: `2px solid ${color}`,
            margin: 'auto'
          }}
        >
          <tbody>
            <tr
              style={{ backgroundColor: color }}
            >
              <td key='listpaginationPrev'>
                <span
                  className='listPaginationItem fa fa-chevron-left fa-lg'
                  style={{
                    color: isPrev ? 'black' : 'lightGray',
                    fontSize: '22px',
                    paddingRight: '10px',
                    paddingBottom: '10px',
                    border: '0px solid red',
                    lineHeight: '30px',
                    verticalAlign: 'top'
                  }}
                  onClick={() => {
                    if (isPrev) {
                      this.props.setPageNumber(this.props.paginationMapKey, pageNumber - 1)
                    }
                  }}
                />
              </td>
              {pageNumberList.map(pageNo => (
                <td
                  key={`listpaginationTD${pageNo}`}
                  style={{
                    padding: '0px 0px 4px 0px',
                    verticalAlign: 'middle'
                  }}
                >
                  <span
                    className='listPaginationItem'
                    style={{
                      color: 'black',
                      fontSize: '18px',
                      fontFamily: 'Open Sans',
                      padding: '10px',
                      border: '0px solid red',
                      fontWeight: pageNo === pageNumber ? 'bold' : 'normal',
                      lineHeight: '10px',
                      verticalAlign: 'top'
                    }}
                    onClick={() => this.props.setPageNumber(this.props.paginationMapKey, pageNo)}
                  >
                    {pageNo}
                  </span>
                </td>
              ))}
              <td key='listpaginationNext'>
                <span
                  className='listPaginationItem fa fa-chevron-right fa-lg'
                  style={{
                    color: isNext ? 'black' : 'lightGray',
                    fontSize: '22px',
                    paddingLeft: '10px',
                    paddingBottom: '10px',
                    border: '0px solid red',
                    lineHeight: '30px',
                    verticalAlign: 'top'
                  }}
                  onClick={() => {
                    if (isNext) {
                      this.props.setPageNumber(this.props.paginationMapKey, pageNumber + 1)
                    }
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default ListPagination



// WEBPACK FOOTER //
// ./src/mi-app/digitalAssistant/ListPagination.js